import React from 'react';
import { EyeIcon, ArrowRightIcon, SparklesIcon, ImageIcon, LightbulbIcon, FileTextIcon } from 'lucide-react';
export const KeyInsights: React.FC = () => {
  return <div className="space-y-8 bg-white p-8 rounded-sm shadow-[0_2px_8px_rgba(0,0,0,0.05)] border border-[#F2F3F5]" data-id="element-222" data-mp="18o41lvss7z11">
      {/* Key Insights Section */}
      <div className="w-full" data-id="element-223" data-mp="13pkhm0xr0xbb">
        <div className="flex items-center space-x-3 mb-6" data-id="element-224" data-mp="13rdewpmh256n">
          <LightbulbIcon className="h-6 w-6 text-[#D1005D]" data-id="element-225" data-mp="g0808ds9pixx" />
          <h3 className="text-xl font-semibold text-[#141617]" data-id="element-226" data-mp="by4nzmxryabl">
            Key Insight: The Power of Colour Contrast in Retail Environments
          </h3>
        </div>
        <p className="text-[#212326] leading-relaxed" data-id="element-227" data-mp="pvjhp3v2949d">
          In a visually complex and premium environment, subtle design choices
          often fail to break through the noise. The results show that warm,
          high-contrast backgrounds act as critical visual anchors. The red
          variant successfully interrupted the ambient visual pattern, proving
          that stopping power requires a distinct visual departure from the
          immediate physical surroundings.
        </p>
      </div>
      {/* Recommendations Section */}
      <div className="mt-12" data-id="element-228" data-mp="1oewseacetd8a">
        <div className="flex items-center space-x-3 mb-8" data-id="element-229" data-mp="1ofpp0ihnmmcp">
          <SparklesIcon className="h-6 w-6 text-[#D1005D]" data-id="element-230" data-mp="1tessvzlwemj3" />
          <h3 className="text-xl font-semibold text-[#141617]" data-id="element-231" data-mp="1tbwxoj1fqbyc">
            Recommendations & Next Steps
          </h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-232" data-mp="10p2h3x7qnwq5">
          {/* Implement Winning Creative */}
          <div className="bg-[#D1005D]/5 p-6 rounded-sm border border-[#D1005D]/10 hover:shadow-[0_4px_12px_rgba(0,0,0,0.05)] transition-shadow" data-id="element-233" data-mp="15oeza4no0fme">
            <div className="flex items-center space-x-3 mb-4" data-id="element-234" data-mp="1ahhwcmrni77c">
              <div className="p-2 bg-[#D1005D]/10 rounded-sm" data-id="element-235" data-mp="cyy97dnipatc">
                <ArrowRightIcon className="h-5 w-5 text-[#D1005D]" data-id="element-236" data-mp="hyugpmvfbkdn" />
              </div>
              <h4 className="font-medium text-[#141617]" data-id="element-237" data-mp="9yeqtd36nlt9">
                Implement Winning Asset
              </h4>
            </div>
            <div className="space-y-3 text-sm text-[#212326] leading-relaxed" data-id="element-238" data-mp="503f0wtbv18e">
              <p data-id="element-239" data-mp="jny6k9vlmzjw">
                Deploy the "Red Background" variant on the digital pillars
                within the travel retail locations to maximise pre-order
                visibility.
              </p>
            </div>
          </div>
          {/* Guidelines for Future Creatives */}
          <div className="bg-[#D1005D]/5 p-6 rounded-sm border border-[#D1005D]/10 hover:shadow-[0_4px_12px_rgba(0,0,0,0.05)] transition-shadow" data-id="element-240" data-mp="3i63hf3qsdj40">
            <div className="flex items-center space-x-3 mb-4" data-id="element-241" data-mp="zb5s3kggwc4">
              <div className="p-2 bg-[#D1005D]/10 rounded-sm" data-id="element-242" data-mp="3s3hy94gmg9wu">
                <EyeIcon className="h-5 w-5 text-[#D1005D]" data-id="element-243" data-mp="3s6dwyv0an2mc" />
              </div>
              <h4 className="font-medium text-[#141617]" data-id="element-244" data-mp="1cb2824vhgvqx">
                Colour Contrast Wins
              </h4>
            </div>
            <div className="space-y-3 text-sm text-[#212326] leading-relaxed" data-id="element-245" data-mp="1exbc5peyrvpx">
              <p data-id="element-246" data-mp="1ezeb4yy3gz6s">
                Maintain high colour saturation and luminance contrast in future
                out-of-home and in-store displays to ensure the message is
                registered by fast-moving travellers.
              </p>
            </div>
          </div>
          {/* Follow-Up Tests */}
          <div className="bg-[#D1005D]/5 p-6 rounded-sm border border-[#D1005D]/10 hover:shadow-[0_4px_12px_rgba(0,0,0,0.05)] transition-shadow" data-id="element-247" data-mp="1a01ly7jr3g11">
            <div className="flex items-center space-x-3 mb-4" data-id="element-248" data-mp="22luiw0id80fw">
              <div className="p-2 bg-[#D1005D]/10 rounded-sm" data-id="element-249" data-mp="1ovr1pnycewxb">
                <ImageIcon className="h-5 w-5 text-[#D1005D]" data-id="element-250" data-mp="1ov8z89l37mgy" />
              </div>
              <h4 className="font-medium text-[#141617]" data-id="element-251" data-mp="1svje6bquxn7y">Follow-Up Tests</h4>
            </div>
            <ul className="text-sm text-[#212326] space-y-2" data-id="element-252" data-mp="2glvlbkea3fxh">
              {['Test Human Faces: Introduce a human face into the creative. Faces are exceptionally strong attention-capturing stimuli.', 'Test Eye Gaze: Use a model making direct eye contact with the camera.', 'Test Emotional Expressions: Explore adding a positive emotional expression to the creative, like happiness or surprise.', 'Test Dynamic Elements: Introduce subtle animation to the red ribbon.'].map(item => <li key={item} className="flex items-start space-x-2" data-id="element-253" data-mp="1gg35egh6crg9">
                  <div className="w-1.5 h-1.5 bg-[#D1005D] rounded-sm mt-1.5 flex-shrink-0" data-id="element-254" data-mp="1ghed2rdqqjcn"></div>
                  <span className="leading-relaxed" data-id="element-255" data-mp="1bitbaniubrm3">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </div>;
};